import React from 'react';
import { Icon } from '../../../Components/Icons';
import { Text } from '../../../globalStyles';

export const NoContractAlert = () => {
  return (
    <div className="bg-white pa3 br2 bl bw3 b--red " style={{ minWidth: '240px' }}>
      <div className="flex flex-row">
        <Icon icon="iconsAlertSvg" size={20} className="ph2 pt1" />
        <Text.body>No contracts inputted for this organization.</Text.body>
      </div>
    </div>
  );
};
